module.exports = __webpack_public_path__ + "8b1b3789b84e2b1b2cd966bb7f2c3d42.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/apple-s.png
// module id = 1811
// module chunks = 0